import { slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import API, { createMAX, getAuthInfo, handlePermissionsUpdate } from '@zillow/mortgage-api-client';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useLocallyStoredObject, useStoreValidFieldsLocally } from '../../utils/form/persist-hooks.js';

function CalculatorForm(props) {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    persistedDefaultValuesDisabled = _useState2[0],
    setPersistedDefaultValuesDisabled = _useState2[1];
  useEffect(function enablePersistedDefaultValuesAfterInitialRenderInBrowser() {
    setPersistedDefaultValuesDisabled(false);
  }, []);
  return /*#__PURE__*/React.createElement(LoadedCalculatorForm, _extends({
    key: persistedDefaultValuesDisabled.toString(),
    persistedDefaultValuesDisabled: persistedDefaultValuesDisabled
  }, props));
}
function LoadedCalculatorForm(_ref) {
  var persistedDefaultValuesDisabled = _ref.persistedDefaultValuesDisabled,
    calcTypeForMarketing = _ref.calcTypeForMarketing,
    children = _ref.children,
    className = _ref.className,
    defaultValues = _ref.defaultValues,
    fieldStorageKey = _ref.fieldStorageKey,
    editorMode = _ref.editorMode,
    onSubmit = _ref.onSubmit;
  var form = useForm({
    mode: 'onTouched',
    defaultValues: useLocallyStoredObject(fieldStorageKey, defaultValues, {
      disablePersistance: persistedDefaultValuesDisabled || editorMode
    })
  });
  useStoreValidFieldsLocally(fieldStorageKey, form, {
    disablePersistance: editorMode
  });

  // Trigger marketing hit on first form change.
  useEffect(function () {
    if (!calcTypeForMarketing) {
      return;
    }
    var _form$watch = form.watch(function () {
        triggerMarketing(calcTypeForMarketing);

        // Unsubscribe after first change.
        unsubscribe();
      }),
      unsubscribe = _form$watch.unsubscribe;

    // eslint-disable-next-line consistent-return
    return function () {
      unsubscribe();
    };
  }, []);
  return /*#__PURE__*/React.createElement("form", {
    className: className,
    onSubmit: form.handleSubmit(onSubmit || Function.prototype)
  }, /*#__PURE__*/React.createElement(FormProvider, form, children));
}
function triggerMarketing(calcTypeForMarketing) {
  return new Promise(function ($return, $error) {
    if (!API.MAX) {
      if (!window._zconfig.serverURLs.MAX) {
        return $error(new Error('MAX serverURL is not set'));
      }
      createMAX(window._zconfig.serverURLs.MAX);
    }
    return Promise.resolve(getAuthInfo()).then(function ($await_1) {
      try {
        return Promise.resolve(handlePermissionsUpdate($await_1)).then(function ($await_2) {
          try {
            // Not logged in, so don't trigger marketing.
            if (!API.user) {
              return $return();
            }
            return Promise.resolve(API.MAX.POST({
              action: 'initiateCalculatorFollowupForUser',
              includeAuth: true,
              // IMPORTANT!
              authentication: 'error',
              input: {
                calculatorType: calcTypeForMarketing
              }
            })).then(function ($await_3) {
              try {
                return $return();
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }, $error);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      } catch ($boundEx) {
        return $error($boundEx);
      }
    }, $error);
  });
}
CalculatorForm.defaultProps = {
  children: undefined,
  className: undefined,
  defaultValues: undefined,
  editorMode: false,
  calcTypeForMarketing: undefined
};
CalculatorForm.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string,
  editorMode: PropTypes.bool,
  fieldStorageKey: PropTypes.string.isRequired,
  defaultValues: PropTypes.shape({}),
  calcTypeForMarketing: PropTypes.string,
  onSubmit: PropTypes.func
} : {};

export { CalculatorForm as default };
